module.exports = __webpack_public_path__ + "static/media/yogurt.e1cb9a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/yogurt.png
// module id = 93
// module chunks = 0